import { render, staticRenderFns } from "./InputAmountItem.vue?vue&type=template&id=6610bf05&scoped=true"
import script from "./InputAmountItem.vue?vue&type=script&lang=js"
export * from "./InputAmountItem.vue?vue&type=script&lang=js"
import style0 from "./InputAmountItem.vue?vue&type=style&index=0&id=6610bf05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610bf05",
  null
  
)

export default component.exports